import React from 'react';
import { IndexRoute, Redirect, Route, Router } from 'dva/router';
import IndexPage from './routes/IndexPage';
import Meeting from './routes/Meeting.js';
import MeetingList from './routes/MeetingList.js';
import MenuContainer from './components/MenuContainer';
import App from './routes/App.js';
import Main from './components/layout/Main';
import Undefined from './routes/Undefined';
import Player from './routes/Player';
import MeetingInfo from './routes/MeetingInfo';
import MeetingCtrl from './routes/MeetingControl';
import Personalization from './routes/Personalization/Personalization';
import PersonalizationAppIndex from './routes/Personalization/PersonalizationAppIndex';
import TestPage from './routes/TestPage';
import { PATH_HOME, PATHS } from './utils/constants';
import {
  BoardManage,
  DeptUserManage,
  DeviceManage,
  LogManage,
  NoticeManage,
  PolicyManage,
  PortManage,
  RoleManage,
  RoomManage,
  ServiceManage,
  SupportManage,
  VideoManage,
  WorkdayManage,
  LicensePage
} from './routes/SystemConfig';
import { MeetingAudit, SvcAudit } from './routes/AuditManage';
import CustomReport from './routes/CustomReport';
import CustomReportShow from './routes/CustomReportShow';
import RoomReport from './routes/RoomReport';
import MeetingReport from './routes/MeetingReport';
import UserReport from './routes/UserReport';
import RoomReportDetails from './routes/roomReportDetails';
import RoomAbnormallyReport from './routes/RoomAbnormal';
import RoomAbnormalDetail from './routes/RoomAbnormalDetail';
import UserAbnormallyReport from './routes/UserAbnormal';
import UserAbnormalDetail from './routes/UserAbnormalDetail';
import ReleaseReport from './routes/ReleaseReport';
import PanelAlarm from './routes/PanelAlarm';
import PanelMonitor from './routes/PanelMonitor';
import FaultStatistics from './routes/FaultStatistics';
import Delay from './routes/Delay';
import Personal from './routes/Personal';
import SysConfig from './routes/SysConfig';
import SysLog from './routes/SysLog';
import SysParamManage from "./routes/SystemConfig/SysParamManage";
import RoomOccupyReport from './routes/RoomOccupyReport';
import MeetingBillReport from './routes/MeetingBillReport';

export default ({ history }) => {
  return (
    <Router history={history}>
      <Route path={PATH_HOME} component={App}>
        <Route path={PATHS.delayMeeting} component={Delay} />
        <IndexRoute component={IndexPage} />
        <Route path={PATHS.test} component={TestPage} />
        <Route component={Main}>
          <Route path={PATHS.blank} component={() => null} />
          <Route path={PATHS.meeting} component={Meeting} />
          <Route path={PATHS.list} component={MeetingList} />
          <Route path={PATHS.meetingInfo} component={MeetingInfo} />
          <Route path={PATHS.meetingCtrl} component={MeetingCtrl} />
          <Route
            path={PATHS.audit}
            component={defaultProps => {
              return (
                <MenuContainer {...defaultProps} parentPath={PATHS.audit} />
              );
            }}
          >
            <Route path={PATHS.meetingAudit} component={MeetingAudit} />
            <Route path={PATHS.svcAudit} component={SvcAudit} />
          </Route>
          <Route
            path={PATHS.account}
            component={defaultProps => {
              return (
                <MenuContainer {...defaultProps} parentPath={PATHS.account} />
              );
            }}
          >
            <Route path={PATHS.deptUserManage} component={DeptUserManage} />
            <Route path={PATHS.roleManage} component={RoleManage} />
            <Route path={PATHS.roomManage} component={RoomManage} />
            <Route path={PATHS.boardManage} component={BoardManage} />
            <Route path={PATHS.serviceManage} component={ServiceManage} />
            <Route path={PATHS.supportManage} component={SupportManage} />
            <Route path={PATHS.deviceManage} component={DeviceManage} />
            <Route path={PATHS.portManage} component={PortManage} />
            <Route path={PATHS.log} component={LogManage} />
            <Route path={PATHS.videoManage} component={VideoManage} />
            <Route path={PATHS.workDay} component={WorkdayManage} />
            <Route path={PATHS.noticeManage} component={NoticeManage} />
          </Route>
          <Route
            path={PATHS.controlBoard}
            component={defaultProps => {
              return (
                <MenuContainer
                  {...defaultProps}
                  parentPath={PATHS.controlBoard}
                />
              );
            }}
          >
            <Route path={PATHS.boardMonitor} component={PanelMonitor} />
            <Route path={PATHS.boardFault} component={FaultStatistics} />
            <Route path={PATHS.boardAlarm} component={PanelAlarm} />
          </Route>

          <Route
            path={PATHS.personalConfig}
            component={defaultProps => {
              return (
                <MenuContainer
                  {...defaultProps}
                  parentPath={PATHS.personalConfig}
                />
              );
            }}
          >
            <Route path={PATHS.personalization} component={Personalization} />
          </Route>
          <Route path={PATHS.customReport} component={CustomReport} />
          <Route path={PATHS.customReportShow} component={CustomReportShow} />
          <Route path={PATHS.meetingReport} component={MeetingReport} />
          <Route path={PATHS.roomReport} component={RoomReport} />
          <Route path={PATHS.userReport} component={UserReport} />
          <Route path={PATHS.roomReportDetails} component={RoomReportDetails} />
          <Route path={PATHS.meetingReleaseReport} component={ReleaseReport} />
          <Route path={PATHS.roomOccupyReport} component={RoomOccupyReport} />
          <Route path={PATHS.meetingBillReport} component={MeetingBillReport}
          />
          <Route
            path={PATHS.roomAbnormallyReport}
            component={RoomAbnormallyReport}
          />
          <Route
            path={PATHS.roomAbnormalDetail}
            component={RoomAbnormalDetail}
          />
          <Route
            path={PATHS.userAbnormallyReport}
            component={UserAbnormallyReport}
          />
          <Route
            path={PATHS.userAbnormalDetail}
            component={UserAbnormalDetail}
          />
          <Route path={PATHS.personal} component={Personal} />
          <Route path={PATHS.policy} components={PolicyManage} />
          <Route path={PATHS.appIndex} component={PersonalizationAppIndex} />
          <Route path={PATHS.license} component={LicensePage}/>
          <Route path={PATHS.sysParam} component={SysParamManage} />
          <Route path={PATHS.sysLog} component={SysLog} />
        </Route>
        <Route path={`${PATH_HOME}player`} component={Player} />
        <Route path={`${PATH_HOME}undefined`} component={Undefined} />
        <Route path={PATHS.sysConfig} component={SysConfig} />
        <Redirect from={`${PATH_HOME}*`} to={PATH_HOME} />
      </Route>
    </Router>
  );
};



// WEBPACK FOOTER //
// ./src/router.js